import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./PetEvents.css";

const PetEvents = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <>
      <section className="services-page">

        {/* Banner */}
        <div className="service-banner">
          <div className="overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h1>Services</h1>
                <p>Join our vibrant community at exciting pet events</p>
              </div>

              <div className="col-lg-6 text-end">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
                  alt="Pets"
                  className="img-fluid banner-pets"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Service Card */}
        <div className="service-section">
          <div className="container">

            <div className="service-card">
              <div className="row">
                <div className="col-md-5">
                  <div className="service-content">
                    <h1 className="font-bold mb-4">
                      Pet Events
                    </h1>
                    <p className="font-semibold">
                      Join our vibrant community at exciting pet events and activities. From meetups and workshops to adoption drives and pet-friendly festivals, there's always something fun happening.
                    </p>
                    <p>
                      Connect with fellow pet lovers, learn from experts, and create wonderful memories with your pet at our regularly organized events.
                    </p>
                    <a className="btn btn-dark rounded-pill px-4 w-50 mt-4 font-semibold py-2" href="/ServicesListing">
                      Back to Services
                    </a>
                  </div>
                </div>
                <div className="col-md-7 pe-0">
                  <div className="service-image">
                    <img
                      className="w-100"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/services_icon/events.png`}
                      alt="Pet Events"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </section>
    </>
  );
};

export default PetEvents;
